<template>
  <div class="project-details-section">
      <div class="pd-avatar custom-pd-avatar">
        <img class="custom-pd-avatar-img" v-if="previewUrl == null" :src="$defaultImg">
        <img class="custom-pd-avatar-img" v-if='previewUrl' :src="previewUrl">
        <form class="image-form" enctype="multipart/form-data" @submit.prevent="formSubmit">
          <label class="submit-image-label" for='submitImage'><i @click='openFileStack()' class="fas fa-plus camera-icon"></i></label>
        </form>
      </div>

      <div class="pd-form">

        <div class="pd-li">
          <div class="pd-label">
            Step 1: Title
          </div>
          <div class="pd-input">
            <input type="text" v-model="project.title" placeholder="Your Title Goes Here...">
          </div>
        </div>

        <div class="pd-li">
          <div class="pd-label">
            Step 2: Personal Or Team 
          </div>
          <div class="pd-input">
           
            <v-col class="d-flex" cols="12" sm="12" style="height: 58px;padding: 0;">
              <v-select
                :items="selectOptions"
                item-value="value"
                outlined
                v-model='project.privacy'
                style="font-weight:600;background: #fff;"
              ></v-select>
            </v-col>

            <!--<input type="text" v-model="searchString" placeholder="Type Search...">-->
          </div>
        </div>

        <div class="pd-li" style="margin-bottom: 8px;">
          <div class="pd-label">
            Step 3: Select Template
          </div>
        </div>

        <div class="pd-li" style="width: calc(100% + 20px);margin-left: -10px;">
          <div v-for='type in types' class="pd-icon-li" @click="selectCategory(type)">
            <div class="pd-type-icon" :class="{'pd-type-icon-custom': type.active}">
              <v-icon class='type-icon'>{{type.icon}}</v-icon>
            </div>
            <div class="pd-type-text">
              {{type.title}}
            </div>
          </div>
        </div>

      </div>

      <div style="clear: both;"></div>

      <div style="width:100%;text-align: center;">
        <v-btn depressed color="primary" style='text-align: center;' @click='formSubmit'>
          Create
        </v-btn>
      </div>

  </div>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import globalVar from '@/globals'

export default {
  name: 'ProjectList',
  components: {
    
  },

  data () {
  	return {
      file: null,
      previewUrl: null,
      previewImg: {
        width: 0,
        height: 0,
        left: 0,
        right: 0
      },
      project: {
        title: '',
        type: 'Blank Slate',
        privacy: 'personal'
      },
      types: [
        {
          icon: 'fas fa-wallet',
          title: 'Blank Slate',
          active: true
        },
        {
          icon: 'fas fa-book',
          title: 'Create a Book',
          active: false
        },
        {
          icon: 'fas fa-users',
          title: 'Members Area',
          active: false
        },
        {
          icon: 'fas fa-user-friends',
          title: 'Presentation',
          active: false
        },
        {
          icon: 'fas fa-chalkboard-teacher',
          title: 'Speech',
          active: false
        },
        {
          icon: 'fas fa-list-alt',
          title: 'Future Plans',
          active: false
        },
        {
          icon: 'fas fa-signal',
          title: 'Marketing Strat',
          active: false
        },
        {
          icon: 'fas fa-envelope-open-text',
          title: 'Email Sequence',
          active: false
        },
        {
          icon: 'fas fa-list-ul',
          title: 'Daily Juornal',
          active: false
        },
        {
          icon: 'fas fa-th-list',
          title: 'Perfect Webinar',
          active: false
        },
        {
          icon: 'fas fa-address-card',
          title: 'Syllabus',
          active: false
        },
        {
          icon: 'fas fa-poll',
          title: 'Essay',
          active: false
        },
        {
          icon: 'fas fa-poll-h',
          title: 'Slot Analysis',
          active: false
        },
        {
          icon: 'fas fa-mail-bulk',
          title: 'V2MOM',
          active: false
        }
      ],
  	  colors: ['#f4a261', '#2a9d8f', '#e76f51', '#264653', '#e9c46a'],
      color: '#f4a261',
      searchString: '',
      selectOptions: [
        { text: 'Personal', value: 'personal' },
        { text: 'Team', value: 'team' },
      ],
  	}
  },

  computed: {
    filteredTypes () {
      return this.types.filter(type => {
          return type.title.toLowerCase().indexOf(this.searchString.toLowerCase()) != -1
      })
    }
  },

  methods: {

    randColor () {
      this.color = this.colors[Math.floor(Math.random() * this.colors.length)]
    },

    selectCategory (type) {

      this.types.forEach(item => {
        item.active = false
      })

      type.active = true
      this.project.type = type.title
      // this.$router.push('/dashboard')
    },

    async formSubmit(e) {
      let self = this
      e.preventDefault()

      if (this.project.title == '') {
        this.$toasted.show('Enter Title!', { type: 'error' })
        return
      }

      if (this.project.type == '') {
        this.$toasted.show('Choose Type!', { type: 'error' })
        return
      }

      let formData = new FormData();
      formData.append('title', this.project.title)
      formData.append('type', this.project.type)
      formData.append('privacy', this.project.privacy)

      if (this.previewUrl == null) {
        formData.append('img', process.env.VUE_APP_FILE_BASE+'default-avatar.png')
      } else {
        formData.append('img', this.previewUrl)
      }

      const response = await api.projects.store(formData)
      if (response.status < 300) {
        this.$toasted.show('Outline Created!', { type: 'success' })
        this.$router.push('/' + response.data.project.id + '/dashboard')
        console.log('response', response)
      } else {
        console.log('response error', response)
      }

    },

    openFileStack () {
      const options = {
          onUploadDone: file => {
              console.log('file', file.filesUploaded[0])
              this.previewUrl = file.filesUploaded[0].url
          }
      };

      const client = filestack.init(process.env.VUE_APP_FILESTACK_API)
      client.picker(options).open()
    }
  },

  mounted () {
    this.randColor()
  }
}
</script>

<style lang="scss" scoped>

  .project-details-section {
    width: 660px;
    margin: auto;
    margin-top: 60px;

    .pd-avatar {
      position: relative;
      width: 200px;
      height: 200px;
      border-radius: 5px;
      margin: auto;

      .submit-image-label {
        position: absolute;
        right: 10px;
        bottom: 5px;
      }

      .camera-icon {
        font-size: 20px;
        color: #fff;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.6;
        }
      }
    }

    .custom-pd-avatar {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05), 0 3px 10px 0 rgba(0, 0, 0, 0.05);
      background: #fff;
      overflow: hidden;

      .custom-pd-avatar-img {
        height: 100%;
      }
    }

    .pd-form {
      margin-top: 30px;

      .pd-li {
        margin-bottom: 30px;

        .pd-label {
          margin-bottom: 5px;
          font-size: 16px;
          font-weight: 600;
        }

        .pd-input {

          input {
            width: 100%;
            height: 55px;
            padding-left: 15px;
            padding-right: 15px;
            font-size: 16px;
            border: 1px solid #acb4c5;
            border-radius: 5px;
            line-height: 55px;
            outline: none;
            background: #fff;
          }

          ::-webkit-input-placeholder { /* Edge */
            color: #d7dbe3;
          }

          :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #d7dbe3;
          }

          ::placeholder {
            color: #d7dbe3;
          }
        }

        .pd-icon-li {
          float: left;
          width: 116px;
          height: 145px;
          margin-left: 10px;
          margin-right: 10px;
          margin-bottom: 15px;

          .pd-type-icon {
            width: 116px;
            height: 110px;
            line-height: 106px;
            text-align: center;
            border: 1px solid #eee;
            border-radius: 8px;
            background: #fff;
            cursor: pointer;
            transition: all 0.5s;
            
            &:hover {
              border: 1px solid #4c84ff;
            }

            .type-icon {
              font-size: 30px;
              color: #4c84ff;
            }
          }

          .pd-type-icon-custom {
            border: 1px solid #4c84ff;
          }

          .pd-type-text {
            margin-top: 3px;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            color: #656e7e;
          }
        }
      }
    }
  }

</style>
